__turbopack_context__.v({
  "card": "review-card-module-scss-module__ov31cW__card",
  "card-black-v2": "review-card-module-scss-module__ov31cW__card-black-v2",
  "card-bottom": "review-card-module-scss-module__ov31cW__card-bottom",
  "card-coal-mine-canary": "review-card-module-scss-module__ov31cW__card-coal-mine-canary",
  "card-cyanora": "review-card-module-scss-module__ov31cW__card-cyanora",
  "card-future-fuscia": "review-card-module-scss-module__ov31cW__card-future-fuscia",
  "card-image": "review-card-module-scss-module__ov31cW__card-image",
  "card-inner": "review-card-module-scss-module__ov31cW__card-inner",
  "card-name": "review-card-module-scss-module__ov31cW__card-name",
  "masonry-card": "review-card-module-scss-module__ov31cW__masonry-card",
  "scroll-card": "review-card-module-scss-module__ov31cW__scroll-card",
  "star-container": "review-card-module-scss-module__ov31cW__star-container",
});
